/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Theme } from "@mui/material";

export const messageCenterStyle = {
  sortRowColumn: (theme: Theme) => ({
    borderBottom: "none",
    [theme.breakpoints.down("md")]: {
      padding: "1rem 0",
    },
  }),
  actionLink: { display: "block", textAlign: "center", width: { xs: "100%", md: "auto" } },
};
